import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Eye, ImageOff } from "lucide-react";
import { useState } from "react";
import { getShowTenant } from "@/Api/tenants";
import { TypeTenantsProps } from "@/pages/Tenants";
import Grid from "@/components/Grid";
import { Mask } from "@/utils/mask";
import { LoadImage } from "@/components/Loaders/LoadImage";

export const ShowTenantBtn = ({ uuidTenant }) => {
  const [atualTenant, setAtualTenant] = useState({} as TypeTenantsProps);

  const getDataTenant = async () => {
    const { data: responseApi, ok } = await getShowTenant(uuidTenant);
    if (!ok) return console.log("error response");

    setAtualTenant({ ...responseApi.response });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="mx-1 size-7 p-0 text-slate-900 hover:bg-stone-950/10 dark:text-[#F4F4F5]"
          onClick={getDataTenant}
        >
          <Eye className="size-5" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader className="flex flex-col">
          <DialogTitle>Dados da empresa</DialogTitle>
        </DialogHeader>
        <div className="w-full h-auto">
          <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
            <div className="flex flex-col items-center justify-between">
              {atualTenant?.logo ? (
                <LoadImage
                  src={atualTenant?.logo}
                  className="aspect-square object-cover size-36 rounded self-start"
                  iconSize={50}
                />
              ) : (
                <ImageOff className="size-16 text-stone-300 flex-1" />
              )}
              <Grid.Item name="Documento" flex={0}>
                {Mask.maskCpfOrCnpj(atualTenant?.document as string)}
              </Grid.Item>
            </div>
            <div className="flex flex-col gap-4">
              <Grid.Item name="Empresa" flex={0}>
                {atualTenant?.name}
              </Grid.Item>
              <Grid.Item name="E-mail" flex={0}>
                {atualTenant?.email}
              </Grid.Item>
              <Grid.Item name="Telefone">
                {Mask.maskPhone(atualTenant?.phone)}
              </Grid.Item>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
